import React, { useState, useEffect } from 'react';
import { Table, Button ,Spin} from 'antd';
import { getManagerDashboard } from '../../redux/slice';
import { useSelector, useDispatch } from 'react-redux';
import { data } from 'autoprefixer';
import LocalStorage from '../../../../utilities/localStorage.js'

const DashboardTable = ({ columns,search }) => {
  const dispatch = useDispatch();
  const { managerDashboard ,pagination,loading} = useSelector((state) => state.projectList);
  const user_details = LocalStorage.getItem('bbs_user');

  // Initialize pagination state

  // const [pagination, setPagination] = useState({
  //   current: approverDashboard?.paginationInfo?.currentPage,
  //   pageSize: approverDashboard?.paginationInfo?.itemsPerPage,
  //   total: approverDashboard?.paginationInfo?.totalPages, 
  // });

  //console.log('datasource in dashtable: ',dataSource)
  const[currpage,setCurrPage]=useState(1)

  // useEffect(() => {
  //   // Check if paginationInfo is available
  //   if (approverDashboard?.paginationInfo?.itemsPerPage) {
  //     setPagination((prev) => ({
  //       ...prev,
  //       total: approverDashboard.paginationInfo.itemsPerPage,
  //     }));
  //   }
  // }, [approverDashboard]); // Runs when approverDashboard changes


  const handlePageChange = (type) => {
    if (type === 'next' && currpage < pagination?.totalPages) {
      setCurrPage(currpage + 1);
    } else if (type === 'prev' && currpage > 1) {
      setCurrPage(currpage - 1);
    }
  };

  // useEffect(() => {
  //   dispatch(getManagerDashboard({ page: currpage, search}));
  // }, [dispatch, currpage,search]);

    useEffect(() => {
      if (user_details?.user?.id) {
        const payload = {
         // userId: user_details?.user?.id, 
          page: currpage ,
          search, 
          manager_id:user_details?.user?.id
        };
        dispatch(getManagerDashboard(payload));
      }
    }, [dispatch, user_details?.user?.id, currpage, search]); 
  


  // Calculate total pages based on totalItems and pageSize
  //const totalPages = Math.ceil(pagination.total / pagination.pageSize);

  const dataSource=managerDashboard||[]
  console.log('datasourcetable of manager: ',dataSource)
  return (
    <div className="dashboard-table-container">
      <div className="table-wrapper">
        <Table
          dataSource={dataSource}
          columns={columns}
          pagination={false} 
          loading={{
            spinning: loading, // Spinner controlled by Redux loading state
            indicator: <Spin size="large" />, // Custom large spinner
          }}// Disable default Ant Design pagination
        />
      </div>

      <div className="pagination-controls flex items-center justify-between mt-4">
        {/* Display Current Page Info */}
        <div className="page-info text-gray-600">
          Page {currpage} of {pagination?.totalPages}
        </div>

        {pagination?.totalPages > 1 && (
        <div className="pagination-buttons">
          <Button
            disabled={currpage === 1}
            onClick={() => handlePageChange("prev")}
            style={{
              backgroundColor: '#FFFFFF',
              color: '#344054',
              borderStyle: 'solid',
              borderRadius: '8px',
              borderColor: '#D0D5DD',
            }}
          >
            Previous
          </Button>
          <Button
            disabled={currpage === pagination?.totalPages}
            onClick={() => handlePageChange("next")}
            style={{
              marginLeft: '8px',
              backgroundColor: '#FFFFFF',
              color: '#344054',
              borderStyle: 'solid',
              borderRadius: '8px',
              borderColor: '#D0D5DD',
            }}
          >
            Next
          </Button>
        </div>
        )}
      </div>
    </div>
  );
};

export default DashboardTable;

// import React, { useState, useEffect } from 'react';
// import { Table, Button } from 'antd';
// import { getBbsList } from '@features/dashboard/redux/slice';
// import './style.css';
// import { useSelector, useDispatch } from 'react-redux';

// const DashboardTable = ({ dataSource, columns }) => {
//   const dispatch = useDispatch();
//   const { bbsList } = useSelector((state) => state.projectList);

//   const [pagination, setPagination] = useState({
//     current: 1, // Fallback if no data available yet
//     pageSize: 7, // Default page size
//     total: 0, // Default total items
//   });

//   useEffect(() => {
//     if (bbsList?.paginationInfo?.totalItems) {
//       setPagination((prev) => ({
//         ...prev,
//         total: bbsList.paginationInfo.totalItems,
//       }));
//     }
//   }, [bbsList]); // Runs when bbsList changes

//   // Calculate total pages
//   const totalPages = Math.ceil(pagination.total / pagination.pageSize);

//   // Extract the data array from dataSource
//   const data = dataSource?.data || [];

//   // Handle page change
//   const handlePageChange = (page) => {
//     setPagination((prev) => ({
//       ...prev,
//       current: page,
//     }));

//     // Dispatch new data fetch based on current page and page size
//     dispatch(getBbsList({ currentPage: page, itemsPerPage: pagination.pageSize }));
//   };

//   // Paginate the data array based on current page and page size
//   const paginatedData = data.slice(
//     (pagination.current - 1) * pagination.pageSize,
//     pagination.current * pagination.pageSize
//   );

//   return (
//     <div className="dashboard-table-container">
//       <hr />
//       <div className="table-wrapper">
//         <Table
//           dataSource={paginatedData}
//           columns={columns}
//           pagination={false} // Disable default Ant Design pagination
//         />
//       </div>

//       <div className="pagination-controls flex items-center justify-between mt-4">
//         <div className="page-info text-gray-600">
//           Page {pagination.current} of {totalPages}
//         </div>

//         <div className="pagination-buttons">
//           <Button
//             className="btn"
//             disabled={pagination.current === 1}
//             onClick={() => handlePageChange(pagination.current - 1)}
//             style={{
//               backgroundColor: '#FFFFFF',
//               color: '#344054',
//               borderStyle: 'solid',
//               borderRadius: '8px',
//               borderColor: '#D0D5DD',
//             }}
//           >
//             Previous
//           </Button>
//           <Button
//             disabled={pagination.current === totalPages}
//             onClick={() => handlePageChange(pagination.current + 1)}
//             style={{
//               marginLeft: '8px',
//               backgroundColor: '#FFFFFF',
//               color: '#344054',
//               borderStyle: 'solid',
//               borderRadius: '8px',
//               borderColor: '#D0D5DD',
//             }}
//           >
//             Next
//           </Button>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default DashboardTable;
